import { z } from 'zod';
const BaseInputSchema = z.object({
    name: z.string(),
    required: z.boolean(),
    /** INT | FLOAT | STRING | BOOLEAN | COMBO | a link type (MODEL, IMAGE, …) | * */
    type: z.string(),
    default: z.unknown().optional(),
    min: z.number().optional(),
    max: z.number().optional(),
    step: z.number().optional(),
    /** Combo choices — absent for combos filled at run time (not checkable). */
    options: z.array(z.string()).optional(),
    optionsTotal: z.number().int().optional(),
    multiline: z.boolean().optional(),
    tooltip: z.string().optional(),
    /** The editor stores an extra widget value after this one (seed "randomize", the upload button) — doc 35. */
    extraWidgetValue: z.boolean().optional(),
    /** forceInput: a socket only, no widget value in the editor. */
    socketOnly: z.boolean().optional(),
    /** DynamicCombo: per choice, the nested inputs (full "parent.child" names) in widget order. */
    choices: z.record(z.string(), z.array(z.string())).optional(),
});
export const NodeInputSchema = BaseInputSchema.extend({
    /** A dynamic group (COMFY_DYNAMICGROUP_V3, ComfyUI 0.41 LoadLoraModel): rows submitted as "<name>.<row>.<field>". */
    group: z.object({ min: z.number().int(), max: z.number().int(), fields: z.array(BaseInputSchema) }).optional(),
});
export const NodeDefSchema = z.object({
    name: z.string(),
    displayName: z.string(),
    category: z.string(),
    description: z.string(),
    outputNode: z.boolean(),
    inputs: z.array(NodeInputSchema),
    outputs: z.array(z.object({ name: z.string(), type: z.string() })),
});
export const NodeSummarySchema = NodeDefSchema.pick({ name: true, displayName: true, category: true, description: true });
export const NodesResponseSchema = z.object({ nodes: z.array(NodeSummarySchema), total: z.number().int() });
export const NodeResponseSchema = z.object({ node: NodeDefSchema });
//# sourceMappingURL=nodes.js.map